import React, {Component, Fragment} from "react";
import {Link, Route} from "react-router-dom";
import {PropTypes} from 'prop-types';
import {isMobileOnly} from 'react-device-detect';
import * as cookie from "react-cookies";

import {Button, RelativeSwitch, TileLink} from "../components/common/common";
import {
	countMap,
	extractCartData,
	formatPrice,
	isEmpty,
	mapArray,
	mapObjectToArray,
	objectFind,
	relativePath,
	sectionsToSubsections
} from "../lib/tools";
import {reduxWrapper} from "../globalState";
import {StoreView} from './storeView';
import {BannerHeader} from '../components/structure';
import {getImage} from "../lib/api";
import {infoCards, questions} from '../questions';
import {ModalContext} from '../contexts';
import {OnBoardingModal} from "../components/common/modal";
import {InfoCard, QuestonSwipeSlider, UpsaleCard} from '../components/common/cardSlider';
import { ContestRegisterModal } from './competition';
import { PromptModal } from '../components/common/modal';

// Icons
import removeIcon from "../resources/icons/remove-white.svg";

// Images
import drinksImg from "../resources/images/drinks.jpg";
import headerBgImg from "../resources/images/forsideBanner.jpg";
import decorationImg from "../resources/images/hero-decoration.jpg";
import atmosphereImg from "../resources/images/confetti.jpg";
import extraImg from "../resources/images/dj.jpg";
import practicalImg from "../resources/images/tableDecor.jpg";
// import WhiteCloseIcon from "../../resources/icons/x-white.svg";



// Takes care of routing for within the /minfest area
class TileViewRender extends Component {
	static propTypes = {
		sections: PropTypes.object,
	};
	
	state = {
		sections: {}
	};
	
	chosenSection = {};
	
	render() {
		const {sections, contest = false} = this.props;
		
		if (isEmpty(sections)) return null;
		return (
			<RelativeSwitch>
				<Route path=":section" render={({match: {params: {section}}}) => {
					const subSections = sectionsToSubsections(sections);
					this.chosenSection = objectFind(subSections, x => x.vanity.toLowerCase() === section.toLowerCase());
					return (
						<StoreView section={this.chosenSection}/>
					)
				}}/>
				<Route render={() => <TilesList contest={contest}/>}/>
			</RelativeSwitch>
		);
	}
}

export const TileView = reduxWrapper("loadSections")(TileViewRender);

// Renders the whole tile view
class TilesListRender extends Component {
	static contextType = ModalContext;

	constructor(props) {
		super(props);
		this.nav = React.createRef();
		this.tileList = React.createRef();
	}

	state = {
		totals: [],
	};

	tilesTotalArr = [];
	cartTotal = 0;

	calcPrice = (tiles) => {
		let tilesTotalArr = [];
		let cartTotal = 0;
		let tilesArr = Object.values(tiles);
		tilesArr.forEach(x => {
			let sections = x.children;
			let tileTotal = 0;
			
			sections.forEach(y => {
				let sectionTotal = 0;
				if(y.products){
					let products = y.products;
					products.forEach(z => {
						let productTotal = z.qty * Number(z.price);
						sectionTotal += productTotal;
					})
				}
				tileTotal += sectionTotal;
			});
			
			if(tileTotal > 0){
				tilesTotalArr.push({title: x.title, total: tileTotal});
				cartTotal += tileTotal;
			}
		});
		if (cartTotal !== this.cartTotal) {
			this.setState({totals: tilesTotalArr});
			this.cartTotal = cartTotal;
			this.tilesTotalArr = tilesTotalArr;
		}
	};

	componentDidMount(){
		this.props.awaitUserInfo(() => {
			let isOnBoardingShown = cookie.load('SaveParty');
			if(!this.props.userId){
				this.props.awaitCart(data => {
					if (!isEmpty(data) && !isOnBoardingShown) {
						this.context.toggleModal(true, <OnBoardingModal/>)
					}
				});
			}
			
			if(window.sessionStorage.scrollPos){
				window.scrollTo({
					top: window.sessionStorage.scrollPos,
					behavior: 'auto'	
				});
			}
			
			this.calcPrice(this.props.sections);
			// this.context.toggleModal(true, <SetPasswordModal/>)
			
			document.addEventListener('scroll', this.tileNavCalc);
		})
	}

	componentDidUpdate(){
		this.calcPrice(this.props.sections);
	}

	componentWillUnmount(){
		if (typeof(Storage) !== "undefined") {
			window.sessionStorage.scrollPos = window.scrollY;
		}
		document.removeEventListener('scroll', this.tileNavCalc);
	}

	cur_pos = window.scrollY;

	tileNavCalc = () => {
		var tiles = Object.values(this.tileList.current.children);
		var nav = Object.values(this.nav.current.children);
		var nav_height = nav[0] ? nav[0].offsetHeight : null;
		let navContainer = this.nav.current;
		
		tiles.forEach((tile) => {
			var tileTopPos = tile.offsetTop - nav_height;
			var tileBottomPos = tileTopPos + tile.offsetHeight;
			var setActiveLogic = this.cur_pos >= tileTopPos && this.cur_pos <= tileBottomPos;
			if (setActiveLogic) {
				nav.forEach(element => {
					element.classList.remove('active')
					if(element.classList.contains(`${tile.id}`)){
						element.classList.add('active')
						navContainer.scrollTo({
							left: (element.offsetLeft - navContainer.offsetWidth) + (element.offsetWidth + 24)
						})
					}
				})
			}
		});
		this.cur_pos = window.scrollY;
	}

	scrollToSection = (index) => {
		var i = index - 1;
		var ClickedElement = Object.values(this.tileList.current.children)[i];
		var scrollTo = ClickedElement.offsetTop - 42;
		window.scrollTo({
			top: scrollTo,
			behavior: 'smooth'
		});
	}

	prompt = {
		text: "Vil du annullere din reservation?",
		confirm: () => {
			this.props.setPartyInfo({
				data: {reserved: false}
			}).then(() => {
				this.context.toggleModal(false);
			})
		},
		decline: () => {
			this.context.toggleModal(false);
		},
		confirmText: "Ja",
		declineText: "Nej"
	};
	
	cancelReservation = () => {
		this.context.toggleModal(true,
			<PromptModal {...this.prompt}/>
		)
	}

	registerParty = () => {
		var data = JSON.parse(sessionStorage.getItem("contest"));
		
		this.props.apiCall("POST", "/competition/register/current", ({id}) => {
			this.party = {...data, id};
			this.context.toggleModal(true, <ContestRegisterModal partyId={id}/>);
			this.props.invalidateUserInfo();
			this.props.invalidateEntries();
		}, data, () => alert("Du kan kun registrere din fest en gang."))
	};

	render(){
		const {cart, sections} = this.props;
		const total = countMap(this.state.totals, x => x.total);	
		return (
			<Fragment>
				<BannerHeader bgImage={headerBgImg}>
					<h1 className="headline">Lav din drømmefest</h1>
					<p className="contestTileHeaderText">
						Vælg de produkter du mener man skal bruge for at holde et brag af en fest.<br/>
						Den mest populære fest vinder et gavekort på 5000kr<br/> 
					</p>
				</BannerHeader>
				<div className="sectionNav" ref={this.nav}>
					{
						mapObjectToArray(sections, (x,i) => 
							<div 
								key={i} 
								className={`link${x.code} ${x.code}TileSection`}
								onClick={() => this.scrollToSection(i)}
							>
								{x.title}
							</div>
						)
					}
				</div>
				<div id="tileSection" className={["scrollWrapper", !isEmpty(cart) && "withProd"].join(" ")}>
					<div className="tilesList maxWidth" ref={this.tileList}>
						{
							mapObjectToArray(sections, (x,i) => 
							<Tile key={i} tile={x}/>
							)
						}
					</div>
				</div>
				{
					!isEmpty(cart) &&
					<div className="checkout maxWidth">
						<div className="totalTileBottom">
							<span>Total pris: </span>
							<span>{formatPrice(total)} kr</span>
						</div>
						<div className="tileCheckoutBtns">
							<Button onClick={() => this.registerParty()}>Deltag i konkurrencen</Button>     
						</div>
					</div>
				}
			</Fragment>
		)
	}
}
export const TilesList = reduxWrapper("loadCart", "loadSections", "getUserId", "getPartyInfo", "setPartyInfo", "getApiCall", "invalidateUserInfo", "loadUserInfo", "invalidateEntries")(TilesListRender);

// A single tile
class TileRender extends Component {
	static propTypes = {
		tile: PropTypes.object,
		products: PropTypes.object
	};
	
	state = {
		flipped: false,
		hideFront: false,
		flipping: false,
	};
	
	outerQuestions = [];
	innerQuestions = [];
	infoCards = [];
	
	componentWillMount() {
		const id = this.props.tile.id;
		
		questions.forEach((x, i) => {
			const q = {...x, id: i};
			if (x.section === id) x.inside ? this.innerQuestions.push(q) : this.outerQuestions.push(q);
		});
		
		this.infoCards = infoCards.filter(x => x.section === id);
	}
	
	allocateProducts = (tile, cart) => {
		let sections = [];
		let sectionTotal = 0;
		let hasProducts = false;
		let extraProducts = [];
		let extraSections = {};
		
		tile.children.forEach(section => {
			const { total, products } = (extractCartData(cart, this.props.products, null, section.id));
			sectionTotal += total;
			
			if (products.length > 0)
				hasProducts = true;

			section.products = products.filter(x => {
				if (!x.product.sections) return true;
				
				if (!x.product.sections.includes(x.section.toString())) {
					extraProducts.push(x);
					return false;
				}
				return true;
			});
			sections.push(section);
		});
		
		if (this.props.sections) {
			const subsections = sectionsToSubsections(this.props.sections);
			
			extraProducts.forEach(product => {
				
				const section = subsections[product.product.sections.length < 1 ? 27 : product.product.sections[0]];
				
				if (!extraSections.hasOwnProperty(section.id)) {
					extraSections[section.id] = section;
					extraSections[section.id].products = [];
				}
				
				extraSections[section.id].products.push(product);
			});
		}
		
		return {sections, total: sectionTotal, hasProducts, extraSections};
	};
	
	toggleFlip = () => {
		this.setState(prev => ({flipped: !prev.flipped, flipping: true}));
		
		setTimeout(() => {
			this.setState(prev => ({hideFront: prev.flipped}));
		}, 200);
		
		setTimeout(() => {
			this.setState({flipping: false});
		}, 500);
	};
	
	render() {
		const {tile, partyInfo: {guests, questions = []}} = this.props;
		const {title, code} = tile;
		const section = this.allocateProducts(this.props.tile, this.props.cart);
		let classes = ["flip-container"];
		if (this.state.flipped) classes.push("flip");
		if (this.state.flipping) classes.push("flipping");
		return (
			<Fragment>
				<div className={classes.join(" ")} id={`${code}TileSection`}>
					<section className={`tile tile${code} flipper`}>
						{
							this.state.hideFront ?
								<TileBackSide onClick={this.toggleFlip} section={title}/> :
								<TileFront section={section} tile={tile} innerQuestions={this.innerQuestions} toggleFlip={this.toggleFlip} guests={guests} questions={questions}/>
						}
					
					</section>
				</div>
				{
					this.outerQuestions.length > 0 &&
					<QuestonSwipeSlider cards={this.outerQuestions.length} outer>
						{mapArray(this.outerQuestions, (x, i) => questions && questions.includes(x.id) ? null : <CardShowWrapper question={x} key={i}><UpsaleCard tile={tile}/></CardShowWrapper>)}
					</QuestonSwipeSlider>
				}
				
				{
					this.infoCards.length > 0 &&
					<div className="infoCardsWrapper">
						<QuestonSwipeSlider cards={this.outerQuestions.length} className="infoSlider">
							{mapArray(this.infoCards, (x, i) => questions && questions.includes(x.id) ? null : <CardShowWrapper question={x} key={i}><InfoCard tile={tile}/></CardShowWrapper>)}
						</QuestonSwipeSlider>
					</div>
				}
			
			</Fragment>
		);
	}
}
export const Tile = reduxWrapper("loadCart", "loadProducts", "getCacheProduct", "loadPartyInfo", "loadSections")(TileRender);

const TileFront = ({section: {sections, total, hasProducts, extraSections: exSections}, tile, innerQuestions, toggleFlip, guests, questions = []}) => {
	const {title, description, code} = tile;
	const extraSections = mapArray(exSections, (x, i) => x.products.length < 1 ? null : <SectionWithProd key={i} {...x}/>);
	const prodSections = mapArray(sections, (x, i) => x.products.length < 1 ? null : <SectionWithProd key={i} {...x}/>);
	const sectionButtons = mapArray(sections, (x, i) =>
		<TileLink 
			to={relativePath(`/${x.vanity}`)}
			key={i}
			className={`sectionAdd section${x.code}`}
			img={x.image}>
			{`${x.title}`}
		</TileLink>
	);

	const image = (code) => {
		switch (code) {
			case "food":
				if(prodSections[0] && prodSections[0].props.id && prodSections[0].props.id === 9 && prodSections[0].props.products[0].product.images){
					return getImage(prodSections[0].props.products[0].product.images[0]);
				}else{
					return getImage(5797);
				}
			case "drinks":
				return drinksImg;
			case "decorations":
				return decorationImg;
			case "atmosphere":
				return atmosphereImg;
			case "extra":
				return extraImg;
			case "practical":
				return practicalImg;
			default:
				return getImage(19);
		}
	};

	return (
		<div className="front">
			<div className="tilefrontContainer">
				{ !isMobileOnly && 
					<div className="tileImg" style={{backgroundImage: `url("${image(code)}")`}}>
						{/* <img src={image(code)} alt={title}/> */}
						<div className="tileImgTitle">
							<h1 className="headline">{title}</h1>
						</div>
					</div>
				}

				{hasProducts ? (

					<div className="tileFrontContent withProd">
						<PricePrPerson name={title} price={total} guests={guests} img={image(code)}/>
						{prodSections}
						{extraSections.length > 0 && <h2>Ekstra</h2>}
						{extraSections}
						<div className="emptySections">
							{sectionButtons}
						</div>
						{
							innerQuestions.length > 0 &&
							<QuestonSwipeSlider className="innerSlider">
								{mapArray(innerQuestions, (x, i) => questions && questions.includes(x.id) ? null : <CardShowWrapper question={x} key={i}><UpsaleCard tile={tile}/></CardShowWrapper>)}
							</QuestonSwipeSlider>
						}
					</div>

				) : (

					<div className="tileFrontContent withoutProd">
						{/* <FlipTileBtn onClick={toggleFlip}/> */}
						<TileHeader name={title} text={description}/>
						<div className="emptySections">
							{sectionButtons}
						</div>
					</div>

				)}
			</div>
		</div>
	);
};

//Button to flip the tile to inspiration view
// const FlipTileBtn = ({onClick, children}) => (
// 	<div onClick={onClick} className="flipTileBtn">
// 		<span>{children}</span>
// 		<img src={WhiteCloseIcon}/>
// 	</div>
// );

const TileHeader = ({name, text}) => (
	<div className="tileHeader">
		<h2>{name}</h2>
		<h3>{text}</h3>
	</div>
);

const PricePrPerson = ({name, price, guests, img}) => (
	<div className="pricePrPerson">
		<h1 className="title-l">{name}</h1>
		<div className="priceContainer">
			<span className="headline">{formatPrice(price)}</span>
		</div>
		<img src={img} alt={name}/>
	</div>
);

export const CardShowWrapper = ({question, children, isShown}) => {
	
	const child = React.Children.only(children);
	
	const load = [];
	
	load.push("getCacheProduct");
	load.push("loadProducts");
	
	question.load.forEach(x => {
		if (x === "cartProducts") {
			load.push("loadCart");
		} else
			load.push(x)
	});
	
	const wrapper = reduxWrapper.apply(null, load)(
		({match, ...props}) => {
			
			if (question.load.includes("cartProducts")) {
				
				const {products, total} = extractCartData(props.cart, props.products, props.cacheProduct);
				
				props.cartProducts = products;
				props.total = total;
			}
			
			if (question.products) {
				props.cacheProduct({products: question.products.map(x => x.productId)})
			}
			
			const show = question.show(props);
			
			isShown(show);
			
			if (!show) return null;
			
			return React.cloneElement(child, {match, question, ...props});
		}
	);

	return React.createElement(wrapper);
};

export class SectionWithProd extends Component {
	render() {
		const {title, vanity, products} = this.props;
		return (
			<div className="sectioWithProducts">
				<div className="withProdTitle">
					<div className="line"/>
					<h1 className="title-m">{title}</h1>
				</div>
				{
					products.map((x, i) =>
						<SectionProduct key={i} {...x} vanity={vanity}/>
					)
				}
			</div>
		)
	}
}

class SectionProductRender extends Component {
	
	componentWillMount() {
		this.props.cacheProduct({product: this.props.productId, full: true})
	}
	
	render() {
		const {product: {name, price, thumbnail}, id, deleteCart, qty, vanity} = this.props;
		return (
			<div className="sectionProduct">
				<Link to={relativePath(`/${vanity}/${this.props.product.id}`)}>
					<div className="prodImg">
						<img src={getImage(thumbnail)} alt={name}/>
					</div>
					<div className="prodInfo">
						<span className="prodName">{qty} x {name}</span>
						<span className="prodPrice">{formatPrice(price * qty)}</span>
					</div>
				</Link>
				<div className="deleteProd ga-rmvProd" onClick={() => deleteCart({id})}>
					<img src={removeIcon} alt="fjern"/>
				</div>
			</div>
		)
	}
}
export const SectionProduct = reduxWrapper("getCacheProduct", "deleteCart")(SectionProductRender);

const TileBackSide = ({tips, section, onClick}) => (
	<div className="back">
		<div className="tipsContainer">
			<div className="tipsWrapper">
				<span className="tipsTitle">TIPS AND TRICKS</span>
				{/* {
					tips.map(x => {
						<li>x</li>
					})
				} */}
				<ul>
					<li>Husk lige snaks til velkomst</li>
					<li>En person spiser i gennemsnit 300g</li>
					<li>Har nogen af dine gæster allergier?</li>
					<li>Skal der være en særlig børnemenu?</li>
					<li>Natmad til natteravnene</li>
				</ul>
				{/* <span className="tipsFoldFix"/> */}
			</div>
			<Button onClick={onClick}>Jeg kan godt bruge hjælp til {section.toLowerCase()}</Button>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/contest/tileView.js